module.exports = __webpack_public_path__ + "img/context-menu.77c7051e.svg";